import {Status} from '../../../../helpers/merge-box-status-calculator/stacks-merge-conflicts-and-rebase-section-status'
import type {StacksMergeConflictsAndRebaseSectionProps} from '../types'
import {useId} from 'react'
import {RebaseStackButton} from './shared/RebaseStackButton'
import {AlertIcon} from '../../common/AlertIcon'
import {MergeBoxSectionHeader} from '../../common/MergeBoxSectionHeader'

/**
 * Scenario: the stack is out-of-date with its base branch and can optionally be rebased.
 */
export function OptionalRebase({
  status,
  stackBaseRefName,
  stackEntries,
  stackMetadata,
  canRebase,
  stackBaseRefRequiresSignatures,
}: StacksMergeConflictsAndRebaseSectionProps) {
  const headerId = useId()

  if (status !== Status.StackRebaseOptional) return null

  return (
    <section aria-label="Optional stack rebase" className="border-bottom borderColor-muted" aria-describedby={headerId}>
      <div className="d-flex flex-column width-full overflow-hidden">
        <MergeBoxSectionHeader
          headerId={headerId}
          icon={<AlertIcon />}
          title="This stack is out-of-date with its base branch"
          subtitle={`Rebase this stack onto the latest version of ${stackBaseRefName}.`}
          rightSideContent={
            <RebaseStackButton
              stackEntries={stackEntries}
              stackMetadata={stackMetadata}
              canRebase={canRebase}
              stackBaseRefRequiresSignatures={stackBaseRefRequiresSignatures}
            />
          }
        />
      </div>
    </section>
  )
}
